<template>
  <v-container>
    <v-layout justify-center>
      <v-flex xs12 font-weight-bold ma-5 text-xs-center v-if="loading">
        <v-progress-circular color="secondary" indeterminate :size="50"></v-progress-circular>
      </v-flex>
      <v-flex xs12 font-weight-bold ma-5 text-xs-center v-if="error">
        <v-alert
          :value="error"
          type="error"
          outline
        >
          {{ error }}
        </v-alert>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import OauthService from '@/services/OauthService'

export default {
  data () {
    return {
      error: null,
      loading: null,
    }
  },
  mounted: async function () {
    this.loading = true
    this.error = null
    const code = this.$route.query.code

    if (code === undefined) {
      this.$router.push({
        path: '/logout'
      })
      return
    }

    try {
      const result = await OauthService.processCode(code)
      if (result.data.token) {
        this.$store.dispatch('setToken', result.data.token)


        if (this.$store.getters.loginRedirect) {
          const redirect = this.$store.getters.loginRedirect;
          
          this.$store.dispatch('setLoginRedirect', null)

          this.$router.push({
            path: redirect.path
          })
        } else {
          this.$router.push({
            path: '/'
          })
        }
        return
      }

      this.$router.push({
        path: '/logout'
      })
    } catch (err) {
      this.error = err.response.data.error
    }
    
    this.loading = false
  }
}
</script>

<style scoped>
</style>

